import React from 'react';
import QCXSnackbar from './QCXSnackbar';

export default function QCXSnackbarInfo({ open, content, handleClose, ...restProps }) {
  return <QCXSnackbar open={open} onClose={handleClose} content={content} severity="info" {...restProps} />;
}
